import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { RunLcaOnProducts } from "@tfg/types/schemas/modules/lifeCycleAnalysis/queries/run-lca-on-products"

import { httpClient } from "~/backend/axios.ts"
import { queryClient } from "~/backend/queryClient.ts"
import { showAxiosError } from "~/utils/showAxiosError"

export const useRunLcaOnProductsMutation = (
  options?: UseMutationOptions<unknown, AxiosError, RunLcaOnProducts>
) => {
  return useMutation({
    ...options,
    mutationFn: async (body: RunLcaOnProducts) => {
      return await httpClient.put("/lca/run-lca-on-products", body)
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
      queryClient.invalidateQueries({
        queryKey: ["products", "lca"],
      })
    },
    onError: (error, variables, onMutateResult, context) => {
      options?.onError?.(error, variables, onMutateResult, context)
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
      options?.onError?.(error, variables, onMutateResult, context)
      showAxiosError({
        notificationTitle: "Error",
        notificationMessage: error.message,
        showNotification: true,
        error,
      })
    },
  })
}
